import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

export default function PhoneNumberInput({
	formik,
	name,
	containerStyle = {},
	labelStyle = {},
}) {
	return (
		<Box sx={{ flexGrow: 1, ...containerStyle }}>
			<label
				style={{
					margin: "10px 0px",
					display: "block",
					textWrap: "nowrap",
					...labelStyle,
				}}
				htmlFor={"phoneNumber"}
			>
				Phone Number
				<span style={{ color: "red", marginLeft: "5px" }}>*</span>
			</label>

			<PhoneInput
				country={"pk"}
				value={formik.values[name]}
				inputProps={{
					name: name,
				}}
				inputStyle={{
					borderRadius: "30px",
					margin: 0,
					width: "100%",
					padding: "16.5px 14px 16.5px 58px",
					borderColor: "rgba(145, 158, 171, 0.24)",
					height: "56px",
				}}
				containerStyle={{ margin: 0 }}
				specialLabel=""
				onChange={(phone) => {
					formik.setFieldValue(name, phone);
					formik.setFieldTouched(name, false, false);
				}}
				onBlur={() => {
					formik.setFieldTouched(name, true);
				}}
			/>
			{formik.touched[name] && formik.errors[name] && (
				<Typography sx={{ color: "red" }}>
					{formik.errors[name]}
				</Typography>
			)}
		</Box>
	);
}
